<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: xjf
 * @LastEditTime: 2025-02-21 11:19:05
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>保安列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">保安列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="用户姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="邀请人姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.inviteName"
                    placeholder="请输入邀请人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="用户手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="账号状态">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.status"
                    placeholder="请选择账号状态"
                  >
                    <el-option label="拉黑" value="0"></el-option>
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="待审核" value="2"></el-option>
                    <el-option label="审核失败" value="3"></el-option>
                    <el-option label="资料待完善" value="4"></el-option>
                    <el-option label="已注销" value="5"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="审核状态">
                  <el-select
                    v-model="ruleForm.identity"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="未通过" value="0"></el-option>
                    <el-option label="通过" value="1"></el-option>
                    <el-option label="待审核" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="保安服务状态">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.isJob"
                    placeholder="请选择保安服务状态"
                  >
                    <el-option label="可接单" value="0"></el-option>
                    <el-option label="服务中" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="服务省" prop="type1">
                  <el-select
                    v-model="ruleForm.type1"
                    placeholder="请选择"
                    style="margin-right: auto"
                    @change="cityChange"
                  >
                    <el-option
                      v-for="(item, index) in city"
                      :key="item.adcode"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  label="服务城市"
                  prop="select"
                  v-if="ruleForm.type1 != '100000'"
                >
                  <el-select
                    v-model="ruleForm.select"
                    placeholder="请选择"
                    style="margin-right: auto"
                    @change="cityChange1"
                  >
                    <el-option
                      v-for="(item, index) in city1"
                      :key="item.adcode"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="服务地区" prop="send" v-if="ruleForm.type1 != '100000'">
                  <el-select v-model="ruleForm.send" placeholder="请选择" style="margin-right: auto;">
                    <el-option v-for="(item, index) in city2" :key="item.adcode" :label="item.name"
                      :value="item.adcode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="保安类型">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.accountType"
                    placeholder="请选择保安类型"
                  >
                    <el-option label="企业" value="0"></el-option>
                    <el-option label="企业员工" value="1"></el-option>
                    <el-option label="临勤" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList('new')" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="姓名" align="center" width="130">
            <template slot-scope="scope">
              <span>{{
                scope.row.accountType == 0
                  ? scope.row.companyName
                  : scope.row.cardName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            align="center"
            width="120px"
          >
          </el-table-column>
          <el-table-column
            prop="xwbankStatus"
            label="是否开户"
            align="center"
            width="120px"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.xwbankStatus == 0
                  ? "未开户"
                  : scope.row.xwbankStatus == 1
                  ? "已开户"
                  : scope.row.xwbankStatus == 2
                  ? "开户失败"
                  : "审核中"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="jobsTotal" label="完成任务次数" align="center">
          </el-table-column>
          <el-table-column label="职业" align="center" width="120">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <span v-for="(item, index) in scope.row.bodyguardCerts"
                  >{{ item.careerTypeName }}-{{ item.levelTypeName
                  }}<span v-if="scope.row.bodyguardCerts.length > 1"
                    >/</span
                  ></span
                >
                <div slot="reference" class="name-wrapper">
                  <div class="omit" v-if="scope.row.bodyguardCerts">
                    {{
                      scope.row.bodyguardCerts &&
                      scope.row.bodyguardCerts.length > 1
                        ? "多认证"
                        : "单认证"
                    }}
                  </div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="注册时间"
            align="center"
            width="160px"
          >
          </el-table-column>
          <el-table-column prop="lastLoginCity" label="地区" align="center">
          </el-table-column>
          <el-table-column label="最近登录地区" align="center" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.lastLoginAddress }}</span>
            </template>
          </el-table-column>
          <el-table-column label="保安类型" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.accountType == 0
                  ? "企业"
                  : scope.row.accountType == 1
                  ? "企业员工"
                  : "临勤"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="营业类型" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.businessType == 0 ? "第三方" : "直营" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="微信认证" align="center" width="100px">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.wxVerifiedStatus == 0"
                >未认证</span
              >
              <span class="greenColor" v-if="scope.row.wxVerifiedStatus == 1"
                >已认证</span
              >
            </template>
          </el-table-column>
          <el-table-column label="身份认证" align="center" width="100px">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.cadeVerifyStatus == 0"
                >未通过</span
              >
              <span class="greenColor" v-if="scope.row.cadeVerifyStatus == 1"
                >已通过</span
              >
            </template>
          </el-table-column>
          <el-table-column label="服务状态" align="center" width="120px">
            <template slot-scope="scope">
              <span
                class="blueColor"
                v-if="scope.row.isJob == 0 && scope.row.status != 1"
                >不可接单</span
              >
              <span
                class="greenColor"
                v-if="scope.row.isJob == 0 && scope.row.status == 1"
                >可接单</span
              >
              <span class="redColor" v-if="scope.row.isJob == 1">服务中</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="jobName"
            label="任务名称"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="customName"
            label="发布人名"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="jobEnd"
            label="服务完成时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="账号状态" align="center" width="120px">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.status == 0">拉黑</span>
              <span class="greenColor" v-if="scope.row.status == 1">正常</span>
              <span class="blueColor" v-if="scope.row.status == 2">待审核</span>
              <span class="blueColor" v-if="scope.row.status == 4"
                >资料待完善</span
              >
              <span class="redColor" v-if="scope.row.status == 5">已注销</span>
              <el-popover
                trigger="hover"
                placement="top"
                v-if="scope.row.status == 3"
              >
                <p>{{ scope.row.rejectReason }}</p>
                <div slot="reference" class="name-wrapper">
                  <span class="redColor">审核失败</span>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="pidName"
            label="邀请人"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.inviteName }}</span
              ><span v-if="scope.row.invitePhone && scope.row.invitePhone != ''"
                >({{ scope.row.invitePhone }})</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="lastLoginAddress"
            label="最近登录地址"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="lastLoginProvince"
            label="最近登录省份"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="lastLoginCity"
            label="最近登录城市"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="lastLoginArea"
            label="最近登录地区"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="lastLoginTime"
            label="最近登录时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="手机品牌" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.lastPhoneBrand ? scope.row.lastPhoneBrand : "null"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机型号" align="center" width="120">
            <template slot-scope="scope">
              <span>{{
                scope.row.lastPhoneModel ? scope.row.lastPhoneModel : "null"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机系统号" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.lastPhoneSystemVersion
                  ? scope.row.lastPhoneSystemVersion
                  : "null"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="当前App版本号" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.versionNo ? scope.row.versionNo : "null"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="180"
          >
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn"
                  @click="handleEdit(scope.row)"
                  v-if="scope.row.isExamine == 1 && scope.row.isLogoff == 0"
                >
                  审核
                </div>
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 0"
                >
                  恢复
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.status == 1"
                >
                  拉黑
                </div>
                <!-- isLogoff 是否注销 -->
                <div
                  class="operateBtn redColor1"
                  @click="cancelexamine(scope.row)"
                  v-if="
                    scope.row.isLogoff == 0 &&
                    (scope.row.status == 1 || scope.row.status == 3)
                  "
                >
                  审核撤销
                </div>
                <div class="operateBtn" @click="goDetail(scope.row)">详情</div>
                <div
                  v-if="scope.row.accountType == 0 && scope.row.isLogoff == 0"
                  class="operateBtn"
                  @click="dowLoad(scope.row)"
                >
                  下载二维码
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <TableScrollSlider :table-ref="$refs.scrollTable" />
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="审核信息"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
    >
      <div class="infoBox">
        <div v-if="detail.accountType == 0">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div style="width: 75%">
              <div class="modelTitle">
                {{
                  detail.accountType == 0
                    ? "企业"
                    : detail.accountType == 1
                    ? "企业员工"
                    : detail.accountType == 2
                    ? "临勤"
                    : "消防保安"
                }}信息
              </div>
              <div style="display: flex; flex-wrap: wrap">
                <div class="infoItem">
                  注册类型：{{
                    detail.accountType == 0
                      ? "企业"
                      : detail.accountType == 1
                      ? "企业员工"
                      : detail.accountType == 2
                      ? "临勤"
                      : "消防保安"
                  }}
                </div>
                <div class="infoItem">公司名称：{{ detail.companyName }}</div>
                <div class="infoItem">
                  统一社会信用代码：{{ detail.licenseNo }}
                </div>
                <!-- <el-form
              ref="ruleForm2"
              :model="ruleForm2"
              style="display: flex; flex-wrap: wrap"
            >
              <el-form-item label="所属省" prop="val1">
                <el-select
                  v-model="ruleForm2.val1"
                  placeholder="请选择"
                  style="margin-right: auto; width: 150px"
                  @change="newcityChange"
                >
                  <el-option
                    v-for="(item, index) in newCity"
                    :key="item.areaCode"
                    :label="item.name"
                    :value="item.areaCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="所属市"
                prop="val2"
                style="margin-left: 20px"
              >
                <el-select
                  v-model="ruleForm2.val2"
                  placeholder="请选择"
                  style="margin-right: auto; width: 150px"
                  @change="newcityChange1"
                >
                  <el-option
                    v-for="(item, index) in newCity1"
                    :key="item.areaCode"
                    :label="item.name"
                    :value="item.areaCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="所属区"
                prop="val3"
                style="margin-right: 20px"
              >
                <el-select
                  v-model="ruleForm2.val3"
                  placeholder="请选择"
                  style="margin-right: auto; width: 150px"
                  @change="newcityChange2"
                >
                  <el-option
                    v-for="(item, index) in newCity2"
                    :key="item.areaCode"
                    :label="item.name"
                    :value="item.areaCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="所属街道"
                prop="val4"
                style="margin-right: 30px"
              >
                <el-select
                  v-model="ruleForm2.val4"
                  placeholder="请选择"
                  style="margin-right: auto; width: 150px"
                  @change="getorgList"
                >
                  <el-option
                    v-for="(item, index) in newCity3"
                    :key="item.areaCode"
                    :label="item.name"
                    :value="item.areaCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="监管单位"
                prop="val5"
                style="margin-right: 30px"
              >
                <el-select
                  v-model="ruleForm2.val5"
                  placeholder="请选择"
                  style="margin-right: auto; width: 150px"
                >
                  <el-option
                    v-for="(item, index) in orgList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form> -->
                <div
                  style="display: flex; align-items: center; flex-wrap: wrap"
                >
                  监管单位：
                  <div
                    style="
                      padding: 2px 4px;
                      box-sizing: border-box;
                      border-radius: 6px;
                      background: RGBA(134, 144, 156, 0.5);
                      display: flex;
                      margin-right: 6px;
                    "
                    v-for="(item, index) in selectedRows"
                  >
                    <div>{{ item.name }}</div>
                    <div
                      style="margin-left: 8px; cursor: pointer"
                      @click="close(item)"
                    >
                      ×
                    </div>
                  </div>
                  <el-popover
                    placement="right"
                    width="400"
                    trigger="click"
                    @show="showTab"
                  >
                    <div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                          margin: 10px 0;
                        "
                      >
                        <el-input
                          maxlength="50"
                          clearable
                          v-model="torgValue"
                          placeholder="请输入监管单位名称搜索"
                        ></el-input>
                        <el-button
                          type="primary"
                          @click="getorgList('new')"
                          class="btn"
                          style="margin-left: 10px"
                          >查询</el-button
                        >
                      </div>
                      <el-table
                        :data="orgList"
                        tooltip-effect="dark"
                        ref="multipleTable"
                        @select="handleSelect"
                        @select-all="handleSelectAll"
                        row-key="id"
                      >
                        <el-table-column
                          type="selection"
                          width="55"
                          :reserve-selection="true"
                        >
                        </el-table-column>
                        <el-table-column
                          property="id"
                          label="ID"
                          width="170"
                        ></el-table-column>
                        <el-table-column
                          property="name"
                          label="监管单位"
                        ></el-table-column>
                      </el-table>
                      <el-pagination
                        @current-change="handleCurrentChange1"
                        :current-page.sync="currentPage1"
                        :page-size="10"
                        small
                        layout="total,prev, pager, next"
                        :total="orgTotal"
                        width="80%"
                      >
                      </el-pagination>
                    </div>
                    <div
                      slot="reference"
                      style="cursor: pointer; color: blue; margin-left: 10px"
                    >
                      选择监管单位
                    </div>
                  </el-popover>
                </div>
                <div style="display: flex; margin-top: 10px; margin-left: 10px">
                  <div class="infoItem">
                    注册地址：{{ detail.registerAddress }}
                  </div>
                  <div class="infoItem">
                    注册资金：{{ detail.registeredCapital }}万
                  </div>
                </div>
                <div class="infoItem" style="margin-top: 10px">
                  经营范围：{{ detail.businessScope }}
                </div>
              </div>
            </div>
            <div>
              <div class="infoItem" style="width: 100px; margin-right: 20px">
                <el-image
                  :src="detail.businessLicense"
                  alt=""
                  :preview-src-list="[detail.businessLicense]"
                ></el-image>
              </div>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div style="width: 75%">
              <div class="modelTitle">保安服务许可证信息</div>
              <div style="display: flex; flex-wrap: wrap">
                <div class="infoItem">
                  许可证编号：{{ detail.serviceLicenseNumber }}
                </div>
                <div class="infoItem">服务范围：{{ detail.gscScope }}</div>
              </div>
            </div>
            <div>
              <div class="infoItem" style="width: 100px; margin-right: 20px">
                <el-image
                  :src="detail.guardLicenseUrl"
                  alt=""
                  :preview-src-list="[detail.guardLicenseUrl]"
                ></el-image>
              </div>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div style="width: 75%" v-if="detail.legalPersonResp">
              <div class="modelTitle">法人信息</div>
              <div style="display: flex; flex-wrap: wrap">
                <div class="infoItem">
                  姓名：{{ detail.legalPersonResp.name }}
                </div>
                <div class="infoItem">
                  民族：{{ detail.legalPersonResp.nationality }}
                </div>
                <div class="infoItem">
                  性别：{{ detail.legalPersonResp.sex == 1 ? "男" : "女" }}
                </div>
                <div class="infoItem">
                  出生年月：{{ detail.legalPersonResp.birthday }}
                </div>
                <div class="infoItem">
                  证件有效期：{{ detail.legalPersonResp.cardValidityStart }}-{{
                    detail.legalPersonResp.cardValidityEnd
                  }}
                </div>
                <div class="infoItem">
                  签发机关：{{ detail.legalPersonResp.issuingAuthority }}
                </div>
                <div class="infoItem">
                  地址：{{ detail.legalPersonResp.currentAddress }}
                </div>
              </div>
            </div>
            <div v-if="detail.legalPersonResp">
              <div
                class="infoItem"
                style="width: 200px; margin-right: 20px; display: flex"
              >
                <el-image
                  :src="detail.legalPersonResp.cardPhotoFront"
                  alt=""
                  :preview-src-list="[detail.legalPersonResp.cardPhotoFront]"
                ></el-image>
                <el-image
                  :src="detail.legalPersonResp.cardPhotoBack"
                  alt=""
                  style="margin-left: 10px"
                  :preview-src-list="[detail.legalPersonResp.cardPhotoBack]"
                ></el-image>
              </div>
            </div>
          </div>
        </div>
        <div v-if="detail.accountType != 0">
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div style="width: 75%">
              <div class="modelTitle">
                {{
                  detail.accountType == 0
                    ? "企业"
                    : detail.accountType == 1
                    ? "企业员工"
                    : detail.accountType == 2
                    ? "临勤"
                    : "消防保安"
                }}信息
              </div>
              <div style="display: flex; flex-wrap: wrap">
                <div class="infoItem">
                  注册类型：{{
                    detail.accountType == 0
                      ? "企业"
                      : detail.accountType == 1
                      ? "企业员工"
                      : detail.accountType == 2
                      ? "临勤"
                      : "消防保安"
                  }}
                </div>
                <!-- <div class="infoItem">注册工种：保安</div> -->
                <div class="infoItem">姓名：{{ detail.cardName }}</div>
                <div class="infoItem">
                  性别：{{ detail.sex == 1 ? "男" : "女" }}
                </div>
                <div class="infoItem">身份证号：{{ detail.cardCode }}</div>
                <div class="infoItem">手机号：{{ detail.phone }}</div>
                <div class="infoItem">出生年月：{{ detail.birthday }}</div>
                <div class="infoItem">身高(厘米)：{{ detail.high }}</div>
                <div class="infoItem">体重(公斤)：{{ detail.weight }}</div>
                <div class="infoItem">
                  证件有效期：{{ detail.cardValidity }}
                </div>
                <div class="infoItem">
                  签发机关：{{ detail.issuingAuthority }}
                </div>
                <div class="infoItem">地址：{{ detail.address }}</div>
              </div>
            </div>
            <div style="display: flex">
              <div class="infoItem" style="width: 150px; margin-right: 20px">
                <el-image
                  :src="detail.cardFrontUrl"
                  alt=""
                  :preview-src-list="[detail.cardFrontUrl]"
                ></el-image>
              </div>
              <div class="infoItem" style="width: 150px; margin-right: 20px">
                <el-image
                  :src="detail.cardBackUrl"
                  alt=""
                  :preview-src-list="[detail.cardBackUrl]"
                ></el-image>
              </div>
            </div>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div style="width: 75%">
              <div class="modelTitle">保安证信息</div>
              <div style="display: flex; flex-wrap: wrap">
                <div class="infoItem">
                  保安证件号：{{
                    detail.bodyguardCerts && detail.bodyguardCerts[0]
                      ? detail.bodyguardCerts[0].certNumber
                      : ""
                  }}
                </div>
              </div>
            </div>
            <div style="display: flex; flex-wrap: wrap">
              <div
                class="infoItem"
                style="width: 100px; height: 150px"
                v-for="item in imgList"
              >
                <el-image
                  :src="item.certFrontUrl"
                  alt=""
                  :preview-src-list="[item.certFrontUrl]"
                  style="width: 100px; height: 150px"
                ></el-image>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="modelTitle">审核操作</div>
          <div class="infoItem" style="width: 100%">
            <el-select
              style="margin-right: auto"
              v-model="state"
              placeholder="请选择审核状态"
            >
              <el-option label="通过" value="1"></el-option>
              <el-option label="拒绝" value="0"></el-option>
            </el-select>
          </div>
          <div
            class="infoItem"
            style="width: 100%"
            v-if="detail.accountType != 0 && state == 1"
          >
            <el-select
              style="margin-right: auto"
              v-model="level"
              placeholder="请选择保安等级"
            >
              <el-option
                :label="i.propDesc"
                :value="i.propValue"
                v-for="(i, i1) in tableData1"
                :key="i1"
              >
              </el-option>
            </el-select>
          </div>
          <div class="infoItem" v-if="state == '0'">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入拒绝原因"
              v-model="textarea"
            >
            </el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModel">取 消</el-button>
        <el-button type="primary" @click="shenhe()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="保安公司邀请临勤二维码"
      :visible.sync="dialogVisible1"
      width="1000px"
      :before-close="handleClose1"
    >
      <div style="text-align: center">
        <QRCodeOnImage :qrText="url" :footerText="textUnderQr"></QRCodeOnImage>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
import QRCodeOnImage from "../../components/codePage.vue";
import Template from "../template/template.vue";
export default {
  components: {
    system,
    QRCodeOnImage,
  },
  Template,
  data() {
    return {
      leftList: this.Plugins.askariData(),
      ruleForm: {
        name: "",
        status: "",
        phone: "",
        identity: "",
        inviteName: "",
        isJob: "",
        type1: "",
        select: "",
        send: "",
        accountType: "",
        type1: "",
        select: "",
        isJob: "",
      },
      ruleForm2: {
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        val5: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      selectData: {},
      detail: {},
      state: "",
      level: "",
      textarea: "",
      imgList: [],
      city: [],
      city1: [],
      city2: [],
      srcList: [],
      tableData1: [],
      dialogVisible1: false,
      url: "",
      qrText: "", // 默认二维码内容
      textUnderQr: "", // 默认二维码内容
      newCity: [],
      newCity1: [],
      newCity2: [],
      newCity3: [],
      areaCode: "",
      levelCode: 1,
      orgList: [],
      selectList: [],
      currentPage1: 1,
      torgValue: "", // 监管单位搜索框内容
      orgTotal: 0,
      // ✅ 对外：保存完整的选中对象数组
      selectedRows: [],
      // 🔒 对内：用 Set 存 id，用于快速去重和判断（性能好）
      selectedIdsSet: [], // 默认选中 id=3 和 id=7
      fullRowCache: {},
    };
  },
  mounted() {
    if (this.$route.query.name) {
      this.ruleForm.inviteName = this.$route.query.name;
    }
    this.getList();
    this.getcity();
    // this.newCity = this.getcityList();
    this.qrText =
      window.location.hostname == "manager.baoanlailou.com"
        ? "https://h5.baoanlailou.com/login"
        : "http://h-uat.baoanlailou.com/login";
  },
  computed: {},
  methods: {
    //切换分页
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.getorgList();
    },
    showTab() {
      this.getorgList();
      this.syncSelectedRows();
    },
    getorgList(val) {
      if (val === "new") {
        this.page = 1;
      }
      let param = {
        name: this.torgValue,
        pageSize: 10,
        page: this.currentPage1,
      };
      this.$axios
        .post(`/admapi/sys/org/page`, param)
        .then(({ data }) => {
          this.orgList = data.items;
          this.orgTotal = data.page.totalRows;
          // ✅ 关键：缓存当前页所有行
          this.orgList.forEach((row) => {
            this.fullRowCache[row.id] = row;
          });

          // 同步表格视觉选中状态
          this.$nextTick(() => {
            const table = this.$refs.multipleTable;
            if (!table) return;
            this.orgList.forEach((row) => {
              const isSelected = this.selectedIdsSet.has(row.id);
              table.toggleRowSelection(row, isSelected);
            });
          });

          // ✅ 从缓存生成完整的 selectedRows
          this.syncSelectedRows();
        })
        .catch()
        .finally();
    },
    syncSelectedRows() {
      const rows = Array.from(this.selectedIdsSet)
        .map((id) => this.fullRowCache[id])
        .filter((row) => row != null); // 过滤未加载项（理论上不会出现）

      this.selectedRows = rows;

      console.log("selectedIdsSet:", Array.from(this.selectedIdsSet));
      console.log("selectedRows:", this.selectedRows);
    },
    handleSelect(selection, row) {
      const isSelected = selection.some((item) => item.id === row.id);
      if (isSelected) {
        this.selectedIdsSet.add(row.id);
        // 缓存该行
        this.fullRowCache[row.id] = row;
      } else {
        this.selectedIdsSet.delete(row.id);
      }
      // 更新 selectedRows（从缓存取）
      this.selectedRows = Array.from(this.selectedIdsSet)
        .map((id) => this.fullRowCache[id])
        .filter(Boolean);
    },

    handleSelectAll(selection) {
      const currentPageIds = this.orgList.map((r) => r.id);
      if (selection.length > 0) {
        // 全选当前页
        this.orgList.forEach((row) => {
          this.selectedIdsSet.add(row.id);
          this.fullRowCache[row.id] = row;
        });
      } else {
        // 取消当前页全选
        currentPageIds.forEach((id) => {
          this.selectedIdsSet.delete(id);
        });
      }
      this.selectedRows = Array.from(this.selectedIdsSet)
        .map((id) => this.fullRowCache[id])
        .filter(Boolean);
    },
    //监管单位选择数据
    // handleSelectionChange(val) {
    //   this.selectList = [...val];
    // },
    close(row) {
      const id = row.id;

      // 1. 从选中集合中移除
      this.selectedIdsSet.delete(id);

      // 2. 【关键】如果该行当前在表格中，取消其视觉勾选
      const table = this.$refs.multipleTable;
      if (table && this.orgList.some((r) => r.id === id)) {
        // 找到当前页对应的 row 对象（必须是 orgList 中的引用）
        const currentRowInTable = this.orgList.find((r) => r.id === id);
        if (currentRowInTable) {
          table.toggleRowSelection(currentRowInTable, false); // 取消勾选
        }
      }
      // 3. 重新生成 selectedRows（会自动过滤掉已删除项）
      this.syncSelectedRows();
    },
    closeModel() {
      this.ruleForm2.val1 = "";
      this.ruleForm2.val2 = "";
      this.ruleForm2.val3 = "";
      this.ruleForm2.val4 = "";
      this.ruleForm2.val5 = "";
      this.newCity = [];
      this.newCity1 = [];
      this.newCity2 = [];
      this.newCity3 = [];
      this.orgList = [];
      this.dialogVisible = false;
    },
    // async newcityChange() {
    //   this.levelCode = 2;
    //   this.areaCode = this.ruleForm2.val1;
    //   this.ruleForm2.val2 = "";
    //   this.ruleForm2.val3 = "";
    //   this.ruleForm2.val4 = "";
    //   this.ruleForm2.val5 = "";
    //   this.newCity1 = await this.getcityList();
    //   this.getorgList();
    // },
    // async newcityChange1() {
    //   this.levelCode = 3;
    //   this.areaCode = this.ruleForm2.val2;
    //   this.ruleForm2.val3 = "";
    //   this.ruleForm2.val4 = "";
    //   this.ruleForm2.val5 = "";
    //   this.newCity2 = await this.getcityList();
    //   this.getorgList();
    // },
    // async newcityChange2() {
    //   this.levelCode = 4;
    //   this.areaCode = this.ruleForm2.val3;
    //   this.ruleForm2.val4 = "";
    //   this.ruleForm2.val5 = "";
    //   this.newCity3 = await this.getcityList();
    //   this.getorgList();
    // },
    getcityList() {
      let param = {
        areaCode: this.areaCode,
        levelCode: this.levelCode,
      };
      return this.$axios
        .post(`/admapi/district/list`, param)
        .then((res) => res.data)
        .catch((err) => {
          return []; // 防止中断
        });
    },

    getList1() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "pricePremiumType_bodyguard_level",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.tableData1 = data.items;
        })
        .catch()
        .finally();
    },
    getcity() {
      let param = {
        type: 0,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          let arr = data;
          arr.shift();
          this.city = arr;
          if (this.ruleForm.type1 != "" && this.ruleForm.type1 != "100000") {
            this.getcity1();
          }
        })
        .catch()
        .finally();
    },
    cityChange() {
      if (this.ruleForm.type1 == "100000") {
        this.ruleForm.select = "";
      }
      if (this.ruleForm.type1 != "" && this.ruleForm.type1 != "100000") {
        this.getcity1();
      }
    },
    getcity1() {
      let param = {
        type: 1,
        adcode: this.ruleForm.type1,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city1 = data;
        })
        .catch()
        .finally();
    },
    dowLoad(val) {
      this.selectData = val;
      this.url = this.qrText + "?inviterId=" + val.encryptId;
      let name = val.accountType == 0 ? val.companyName : val.cardName;
      this.textUnderQr = name + "邀请注册二维码";
      this.dialogVisible1 = true;
    },
    getcity2() {
      let param = {
        type: 2,
        adcode: this.ruleForm.select,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city2 = data;
        })
        .catch()
        .finally();
    },
    cityChange() {
      if (this.ruleForm.type1 != "" && this.ruleForm.type1 != "0") {
        this.city1 = [];
        this.city2 = [];
        this.ruleForm.select = "";
        this.ruleForm.send = "";
        this.getcity1();
      }
    },
    cityChange1() {
      if (this.ruleForm.type1 != "" && this.ruleForm.type1 != "0") {
        this.ruleForm.send = "";
        this.city2 = [];
        this.getcity2();
      }
    },
    cancelexamine(val) {
      this.$confirm("是否撤销审核", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
          };
          this.$axios
            .post(`/admapi/bodyguard/cancelexamine`, param)
            .then(({ data }) => {
              this.$message({
                message: "撤销成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    stop(val) {
      this.$confirm(val.status == 1 ? "是否禁用" : "是否启用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.status == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/bodyguard/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.status == 1 ? "禁用成功" : "启用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    shenhe() {
      console.log(this.state);
      if (this.state == "") {
        this.$message({
          message: "请选择审核状态",
          type: "warning",
        });
        return;
      }
      if (this.detail.accountType != 0 && this.state == 1) {
        if (this.level == "") {
          this.$message({
            message: "请选择等级",
            type: "warning",
          });
          return;
        }
      }
      if (this.state == 0) {
        if (this.textarea == "") {
          this.$message({
            message: "请输入拒绝原因",
            type: "warning",
          });
          return;
        }
      }
      let param = {
        id: this.selectData.id,
        reason: this.textarea,
        state: this.state,
      };
      if (this.detail.accountType == 0) {
        let arr = [];
        for (var i = 0; i < this.selectedRows.length; i++) {
          arr.push(this.selectedRows[i].id);
        }
        param.orgIds = arr;
      }
      if (this.detail.accountType != 0) {
        param.bodyguardCerts = [
          {
            careerType: this.imgList[0].careerType || "",
            id: this.imgList[0].id,
            levelType: this.level,
          },
        ];
      }
      this.$axios
        .post(`/admapi/bodyguard/examine`, param)
        .then(({ data }) => {
          if (this.state == 1) {
            this.$message({
              message: "审核成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "拒绝成功",
              type: "success",
            });
          }

          this.dialogVisible = false;
          this.ruleForm2.val1 = "";
          this.ruleForm2.val2 = "";
          this.ruleForm2.val3 = "";
          this.ruleForm2.val4 = "";
          this.ruleForm2.val5 = "";
          this.getList();
        })
        .catch()
        .finally();
    },
    goDetail(val) {
      window.open(
        this.$router.resolve({
          path: "/askariDetail",
          query: {
            id: val.id,
          },
        }).href,
        "_blank"
      );
    },
    async loadProvince(provinceCode) {
      this.levelCode = 1;
      this.areaCode = ""; // 省级查询不需要上级 code
      const data = await this.getcityList();
      this.newCity = data;
      this.ruleForm2.val1 = provinceCode;
    },

    async loadCity(cityCode) {
      this.levelCode = 2;
      this.areaCode = this.ruleForm2.val1; // 使用已选的省 code
      const data = await this.getcityList();
      this.newCity1 = data;
      this.ruleForm2.val2 = cityCode;
    },

    async loadDistrict(districtCode) {
      this.levelCode = 3;
      this.areaCode = this.ruleForm2.val2; // 使用已选的市 code
      const data = await this.getcityList();
      this.newCity2 = data;
      this.ruleForm2.val3 = districtCode;
    },

    async loadStreet(streetCode) {
      this.levelCode = 4;
      this.areaCode = this.ruleForm2.val3; // 使用已选的区 code
      const data = await this.getcityList();
      this.newCity3 = data;
      this.ruleForm2.val4 = streetCode;
    },
    async getDetail() {
      try {
        await this.$axios
          .post(`/admapi/bodyguard/get/${this.selectData.id}`, {
            id: this.selectData.id,
            isExamine: 1,
          })
          .then(async ({ data }) => {
            this.detail = data;
            this.imgList = data.bodyguardCerts;
            const associatedOrgs = data.sysOrgList; // 例如：[{id: 3, name: '公安局'}, ...]
            // 初始化选中状态
            this.selectedIdsSet = new Set(associatedOrgs.map((org) => org.id));
            this.fullRowCache = {}; // 先清空
            associatedOrgs.forEach((org) => {
              this.fullRowCache[org.id] = org; // 预填充缓存
            });
            this.selectedRows = [...associatedOrgs]; // if (data.accountType == 0) {
            //   await this.loadProvince(data.orgProvinceCode);
            //   if (data.orgCityCode != "") {
            //     await this.loadCity(data.orgCityCode);
            //   }
            //   if (data.orgAreaCode != "") {
            //     await this.loadDistrict(data.orgAreaCode);
            //   }
            //   if (data.orgStreetCode != "") {
            //     await this.loadStreet(data.orgStreetCode);
            //   }
            //   if (data.orgId && data.orgId != "") {
            //     await this.getorgList();
            //     this.ruleForm2.val5 = data.orgId;
            //   }
            // }
          })
          .catch()
          .finally();
      } catch (error) {
        console.error("获取详情失败:", error);
      }
    },
    handleEdit(val) {
      this.state = "";
      this.textarea = "";
      this.ruleForm2.val1 = "";
      this.ruleForm2.val2 = "";
      this.ruleForm2.val3 = "";
      this.ruleForm2.val4 = "";
      this.ruleForm2.val5 = "";
      this.selectData = val;
      this.dialogVisible = true;
      this.getDetail();
      this.getList1();
      this.getorgList();
    },
    handleClose() {
      this.state = "";
      this.textarea = "";
      this.selectData = {};
      this.dialogVisible = false;
    },
    handleClose1() {
      // this.qrText = "";
      this.selectData = {};
      this.url = "";
      this.textUnderQr = "";
      this.dialogVisible1 = false;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.ruleForm.phone = "";
      this.ruleForm.identity = "";
      this.ruleForm.inviteName = "";
      this.ruleForm.isJob = "";
      this.ruleForm.type1 = "";
      this.ruleForm.select = "";
      this.ruleForm.send = "";
      this.ruleForm.accountType = "";
      this.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList(val) {
      if (val == "new") {
        this.page = 1;
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.ruleForm.name,
        status: this.ruleForm.status,
        lastLoginProvinceCode: this.ruleForm.type1,
        lastLoginCityCode: this.ruleForm.select,
        phone: this.ruleForm.phone,
        // bodyguardVerifyStatus: this.ruleForm.identity,
        inviteName: this.ruleForm.inviteName,
        isJob: this.ruleForm.isJob,
        lastLoginProvinceCode: this.ruleForm.type1,
        lastLoginCityCode: this.ruleForm.select,
        accountType: this.ruleForm.accountType,
        lastLoginAreaCode: this.ruleForm.send,
      };

      this.$axios
        .post(`/admapi/bodyguard/list`, param)
        .then(({ data }) => {
          this.tableData = data.items || [];
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
.modelTitle {
  padding: 4px 6px;
  background: #1890ff;
  color: #fff;
  border-radius: 5px;
  display: inline-block;
  margin-bottom: 20px;
}
.infoBox {
}

.infoItem {
  margin-bottom: 10px;
  margin-right: 40px;
}

.infoItem img {
  width: 150px;
  height: 100px;
}
.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px;
}

.display-canvas {
  width: 300px;
  height: 330px;
  image-rendering: -moz-crisp-edges;
  image-rendering: -webkit-crisp-edges;
  image-rendering: pixelated;
  image-rendering: crisp-edges;
  border: 1px solid #eee;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.render-canvas {
  display: none;
}

.controls {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 300px;
}
.link {
  padding: 8px 16px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
/* /deep/ .el-dialog {
  margin: 1vh auto 0 !important;
} */
</style>
<style></style>
